import { ChevronDownIcon, FolderUpIcon, UploadIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

/**
 * The one upload menu, opened by both the page header's control and the empty
 * folder's call to action. It draws its own button, chevron included, so every
 * button that opens a menu says so the same way (New task does too).
 *
 * Uploading is what this page is for, so it is the page's primary action and
 * belongs in the header with every other page's primary action, rather than in
 * a toolbar strip drawn inside the listing.
 */
export function UploadMenu({
  onPickFiles,
  onPickFolder,
}: {
  onPickFiles: () => void;
  onPickFolder: () => void;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger render={<Button size="sm" />}>
        <UploadIcon aria-hidden="true" />
        Upload
        <ChevronDownIcon aria-hidden="true" strokeWidth={1.5} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-52">
        <DropdownMenuItem onClick={onPickFiles}>
          <UploadIcon aria-hidden="true" />
          Upload files
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onPickFolder}>
          <FolderUpIcon aria-hidden="true" />
          Upload folder
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
